import { logAndToast } from './logAndToast';
import type { LogHelper } from '@types';

export const logSuccess: LogHelper = async (
  message,
  source,
  context,
  showToast = true,
  forceLog = false
): Promise<void> => {
  await logAndToast({
    message,
    source,
    context,
    toast: showToast,
    level: 'success',
    forceLog
  });
};
